export const HeaderDATA = [
    {
      title: { tr: 'KURUMSAL', en: 'CORPORATE' },
      link: '/kurumsal',
      dropDown: [
        { title: { tr: 'Hakkımızda', en: 'About Us' }, link: '/hakkimizda' },
        { title: { tr: 'Şirket Profili', en: 'Company Profile' }, link: '/hakkimizda' },
        { title: { tr: 'Misyon & Vizyon', en: 'Mission & Vision' }, link: '/hakkimizda' },
        { title: { tr: 'Kalite Politikamız', en: 'Our Quality Policy' }, link: '/hakkimizda' },
        // { title: { tr: 'Sertifikalar', en: 'Certificates' }, link: '/hakkimizda' },
        // { title: { tr: 'E-katalog', en: 'E-Catalog' }, link: '/kurumsal' }
      ]
    },
    {
      title: { tr: 'PROJELER', en: 'PROJECTS' },
      link: '/projeler',
      dropDown: [
        // Gerekirse buraya dropDown eklenebilir
      ]
    },
    {
      title: { tr: 'İLETİŞİM', en: 'CONTACT' },
      link: '/iletisim',
      dropDown: [
        // İletişim alt öğeleri eklenebilir
      ]
    },
    {
      title: { tr: 'POLİTİKALAR', en: 'POLICIES' },
      // link alanı eklenmediği için bu menü dropDown şeklinde kullanılacaktır.
      dropDown: [
        { title: { tr: 'Gizlilik Politikası', en: 'Privacy Policy' }, link: '/politikalar/gizlilik-politikasi' },
        { title: { tr: 'Çerez Politikası', en: 'Cookie Policy' }, link: '/politikalar/cerez-politikasi' }
      ]
    }
  ];
  